type KeyState = Map<string, boolean>;

export class InputManager {
  private _dispose: () => void;
  private paused: boolean = false;
  private keyState: KeyState = new Map<string, boolean>();
  private jumpState: boolean = false;

  constructor(ticker: PIXI.Ticker) {
    const onKeydown = (e: KeyboardEvent) => {
      if (!e.isTrusted) return;
      this.keyState.set(e.code, true);
    };
    const onKeyup = (e: KeyboardEvent) => {
      if (!e.isTrusted) return;
      this.keyState.set(e.code, false);
    };
    window.addEventListener("keydown", onKeydown);
    window.addEventListener("keyup", onKeyup);
    this._dispose = () => {
      this.keyState.clear();
    };
    window.addEventListener("blur", () => this._dispose(), { passive: true });
  }

  dispose() {
    this._dispose();
  }

  pause() {
    this.paused = true;
  }

  start() {
    this.paused = false;
  }

  /**
   * 入力に応じてx軸方向に対する移動量を-1~+1で返す
   */
  get xAxis() {
    if (this.paused) return 0;
    const left = this.keyState.get("ArrowLeft") ?? false;
    const right = this.keyState.get("ArrowRight") ?? false;
    if (left === right) {
      return 0;
    } else if (left) {
      return -1;
    } else {
      return 1;
    }
  }

  get jump() {
    if (this.paused) return false;
    const up = this.keyState.get("ArrowUp") ?? false;
    const keyZ = this.keyState.get("KeyZ") ?? false;
    const newJumpState = up || keyZ;
    const result = newJumpState && this.jumpState !== newJumpState;
    this.jumpState = newJumpState;
    return result;
  }
}
